export default __webpack_public_path__ + "static/media/chip.4218d217.png";